module.exports = __webpack_public_path__ + "img/procheck.767fb773.png";